<div class="p-flex-col-xxs">
  <p-select
    #dateFormatSelect
    trackBy="value"
    placeholder="Select date format"
    [closeOnSelect]="false"
    [options]="selectOptions()"
    [ngModel]="selectedOption()"
    (ngModelChange)="onOptionChange($event)"
  >
    <ng-template #optionTemplate let-option>
      <div class="date-format-option p-w-full">
      @if (isFirstSuggestion(option)) {
      <span class="date-format-option__group p-text-footnote p-color-text-tertiary">Suggested for this data</span>
      } @if (option === firstOtherOption()) {
      <span class="date-format-option__group p-text-footnote p-color-text-tertiary">Other formats</span>
      }
      <div class="p-flex-row-xs p-flex-center-y p-w-full">
        <p-radio class="date-format-option__radio" tabindex="-1" [ngModel]="option === selectedOption()" />
        <div class="date-format-option__text">
          <span class="p-text-footnote">{{ option.name }}</span>
          @if ((option.pattern || option.example) && (option.pattern || option.example) !== option.name) {
          <span class="p-text-footnote p-color-text-tertiary">{{ option.pattern || option.example }}</span>
          } @if (samplePreview(option); as preview) {
          <span class="p-text-footnote p-color-text-secondary">{{ preview }}</span>
          } @if (option === customOption && isCustom()) {
          <p-text-input
            class="date-format-option__custom-input p-w-full"
            placeholder="eg. MM/dd/yyyy"
            [ngModel]="customFormat.value"
            (click)="$event.stopPropagation()"
            (ngModelChange)="onCustomFormatChange($event)"
          />
          }
        </div>
        @if (suggestionFor(option); as suggestion) {
        <p-tag class="date-format-option__match" size="xs" [level]="suggestion.matched === suggestion.total ? 'success' : 'warning'">
          {{ suggestion.matched === suggestion.total ? "Valid dates" : "Some invalid dates" }}
        </p-tag>
        }
      </div>
      </div>
    </ng-template>
    @if (suggestions().length > 0) {
    <ng-template #footerTemplate>
      <p-button-ghosted-sm class="date-format-option__toggle" (click)="showOtherFormats.set(areOthersHidden())">
        {{ areOthersHidden() ? "Show other formats (" + hiddenFormatCount() + ")" : "Hide other formats" }}
      </p-button-ghosted-sm>
    </ng-template>
    }
  </p-select>
  @if (isCustom()) {
  <span class="p-text-footnote p-color-text-secondary">
    Full details on allowable formats are
    <a
      class="p-link"
      href="http://www.joda.org/joda-time/apidocs/org/joda/time/format/DateTimeFormat.html"
      target="_blank"
      >online</a
    >.
  </span>
  }
</div>
